module.exports = "<app-thought-form\r\n  [thought]=\"thought\"\r\n  (thoughtSaved)=\"thoughtSaved($event)\"\r\n  (thoughtCancelled)=\"thoughtCancelled($event)\"\r\n  (thoughtDeleted)=\"thoughtDeleted($event)\"\r\n  (sharesUpdated)=\"isShared()\"></app-thought-form>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/thought-edit/thought-edit.component.html
// module id = ../../../../../src/app/thought-module/thought-edit/thought-edit.component.html
// module chunks = main